export default "__VITE_ASSET__nhOTVt2U__"